import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const GenericHomePageStyles = styled(Box)(({ theme }) => ({
  "& .pageContainerStyles": {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    backgroundColor: theme.palette.grey.light,
    height: theme.pageHeight,
    paddingTop: theme.spacing(8),
  },
  "& .headerGrid": {
    paddingLeft: `${theme.spacing(5)} !important`,
  },

  "& .headerImage": {
    height: "100%",
  },

  "& .headerPaper": {
    boxShadow: theme.shadows.main,
  },
  "& .headerTxtGrid": {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(3),
  },
  "& .headerTitle1": {
    fontSize: theme.typography.pxToRem(28),
    paddingLeft: theme.spacing(0),
  },
  "& .headerSubTitle": {
    paddingLeft: theme.spacing(0),
  },
  "& .iconsBoxes": {
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    height: theme.spacing(22),
  },
  "& .users": {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(5),
  },
}));
